import { alpha } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { gray, brand, red, green, orange } from '../getDesignTokens'; // Import your color palette

export const iconCustomizations = {
  MuiSvgIcon: {
    defaultProps: {
      fontSize: 'medium', 
    },
    styleOverrides: {
      root: ({ theme }) => ({
        transition: 'color 150ms ease-in-out, transform 150ms ease-in-out',
        color: theme.palette.text.primary,
        width: '1.5rem',
        height: '1.5rem',
        // Icons inside buttons must inherit the button's text color, not
        // the forced `text.primary` above — otherwise `contained` buttons
        // (whose root sets `color: white` for text) render dark icons on
        // dark backgrounds. This applies to Button and IconButton alike.
        '.MuiButtonBase-root &': {
          color: 'inherit',
        },
        // Keep adornment/autocomplete icons compact and stable
        '.MuiInputAdornment-root &': {
          width: 18,
          height: 18,
          transform: 'none',
          '&:hover, &:active': { transform: 'none', color: theme.palette.text.secondary },
        },
        '.MuiAutocomplete-root &': {
          width: 18,
          height: 18,
          transform: 'none',
          '&:hover, &:active': { transform: 'none', color: theme.palette.text.secondary },
        },

        // color="primary" on icons follows the app's button convention
        // (dark neutral, near-black), NOT palette.primary.main (which is
        // brand blue). Keeps icons visually aligned with contained buttons.
        // Use color="secondary" to opt into brand blue explicitly.
        '&.MuiSvgIcon-colorPrimary': {
          color: theme.palette.text.primary,
        },
        '&.MuiSvgIcon-colorSecondary': {
          color: brand[500],
        },
        '&.MuiSvgIcon-colorSuccess': {
          color: green[500],
        },
        '&.MuiSvgIcon-colorError': {
          color: red[500],
        },
        '&.MuiSvgIcon-colorWarning': {
          color: orange[500],
        },

        '&:hover': {
          transform: 'scale(1.1)',
          color: theme.palette.primary.dark,
        },
        '&:active': {
          transform: 'scale(0.95)',
        },

        // Dark Mode Adjustments
        ...theme.applyStyles('dark', {
          color: gray[300],
          '&.MuiSvgIcon-colorPrimary': {
            color: theme.palette.text.primary,
          },
          '&.MuiSvgIcon-colorSecondary': {
            color: brand[400],
          },
          '&.MuiSvgIcon-colorSuccess': {
            color: green[300],
          },
          '&.MuiSvgIcon-colorError': {
            color: red[300],
          },
          '&.MuiSvgIcon-colorWarning': {
            color: orange[300],
          },
          '&:hover': {
            color: theme.palette.primary.light,
          },
        }),
      }),
    },
  },
};
